window.openDrawer = window.openDrawer || function(el) {
    const drawer = document.getElementById("side-drawer");
    if (!drawer) {
        console.error("No se encontró el elemento #side-drawer");
        return;
    }

    if (el && el.dataset.title) {
        const titleContainer = drawer.querySelector('.drawer__header h2');
        const bodyContainer = drawer.querySelector('.drawer__body');

        if (titleContainer) titleContainer.innerText = el.dataset.title;
        if (bodyContainer) bodyContainer.innerHTML = el.dataset.content;
    }

    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
};

window.closeDrawer = window.closeDrawer || function() {
    const drawer = document.getElementById("side-drawer");
    if (drawer) {
        drawer.classList.remove("is-open");
        document.body.style.overflow = "";
    }
};

document.addEventListener('click', (event) => 
    event.target.id === 'side-drawer' && closeDrawer());

// Adding a small load delay to the drawer when we load the page to avoid phantom animation
document.addEventListener("DOMContentLoaded", () => {
    const drawer = document.getElementById("side-drawer");
    if (drawer) {
        setTimeout(() => {
            drawer.classList.add("side-drawer--ready");
        }, 100);
    }
});